import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'accepted');
        setIsVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookie_consent', 'declined');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-banner-overlay">
            <div className="cookie-banner">
                <div className="cookie-content">
                    <h4>We value your privacy</h4>
                    <p>
                        We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies in accordance with our <a href="/privacy-policy">Privacy Policy</a>.
                    </p>
                </div>
                <div className="cookie-actions">
                    <button className="btn-outline cookie-btn" onClick={handleDecline}>Decline, Allow Essential Only</button>
                    <button className="btn-filled cookie-btn" onClick={handleAccept}>Accept All</button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
